import * as moment from 'moment';
import { IEventFilter, ICalendarState } from '../classes/calendar';
import { IEvent } from '../custom/classes/event';
import filter from '../components/filters/filter';
import { upsertEventFilter, goToMonth } from '../redux-state/actions/calendar.actions';


export function AddFilterToQuery(currState: ICalendarState<IEvent>): void {
    const serialized = serializeProps(currState);
    if (serialized.length > 0) {
        window.location.hash = encodeURI(serialized);
    }
}

export function GetFilterFromQuery(hash: string, appStore: any): void {
    // Remove hash added for Month scrolling
    let filteredHash = hash.replace(/Month-List-\d*/, "");
    filteredHash = filteredHash.replace(/Month-\d*/, "");
    let urlState = JSON.parse(decodeURI(filteredHash.substr(1)));
    let eventFilters: IEventFilter[] = [];
    urlState.forEach((efilter) => {
        let filter: IEventFilter = {
            key: efilter.key,
            selectedValue: efilter.selectedValue,
            filter: generateEventFilter(efilter.key, efilter.selectedValue)
        };
        eventFilters.push(filter);
    });
    eventFilters.forEach((efilter) => {
        appStore.dispatch(upsertEventFilter(efilter));
        if (efilter.key === "month") {
            const months = efilter.selectedValue.split(',')
            document.documentElement.setAttribute("data-month-preload","true");
            appStore.dispatch(goToMonth(moment(`1 ${months[months.length - 1]}`, "D MMMM YYYY")));
        }
    })
}

function serializeProps(state: ICalendarState<IEvent>): string {
    if (state.eventFilter.length < 1)
        return "";
    return JSON.stringify(state.eventFilter);
}


export function generateEventFilter(propertyToFilter: string, selectedValue: string) {
    return (event: IEvent) => {
        const propertyValue = event[propertyToFilter];
        // If it's an array, check if the value exists inside
        if (propertyValue && propertyValue.constructor === Array) {
            return (propertyValue as any[]).some(item => selectedValue.split(',').filter(v => v.split("|")[0] === item).length > 0);
        } else {
            return selectedValue.split(',').filter(v => v.split("|")[0] === event[propertyToFilter] ).length > 0;
        }
    }
}
